/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Integrations_Wizard_Tools_NoneInputs */



/**
* | output |
* | --- |
* | "This integration adds no tools on its own." |
*
* @param {My_Integrations_Wizard_Tools_NoneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const my_integrations_wizard_tools_none = /** @type {((inputs?: My_Integrations_Wizard_Tools_NoneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Integrations_Wizard_Tools_NoneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diese Integration stellt selbst keine Tools bereit.")
	return /** @type {LocalizedString} */ ("This integration adds no tools on its own.")
});